export const KanbanCardTagStyle =
  'margin-left: 5px; border-radius: 4px; font-weight: 400; padding: 0px 5px; text-align: center; line-height: 20px; height: auto';
